import React from 'react';
import { X } from 'lucide-react';
import ChatPanel from '../../components/Chat/ChatPanel';
import { AdminLayout } from '../../components/layouts';
import { useChat } from '../../context/ChatContext';

const SupportAlerts = () => {
  const { supportAlerts = [], dismissSupportAlert, setActiveConversation } = useChat();

  if (!supportAlerts.length) return null;

  return (
    <div className="fixed left-4 right-4 top-4 z-[1000] flex flex-col gap-2.5 sm:left-auto sm:right-5 sm:w-full sm:max-w-[360px]">
      {supportAlerts.map((alert) => (
        <button
          type="button"
          key={alert.conversationId + alert.at}
          onClick={() => {
            setActiveConversation?.(alert.conversationId);
            dismissSupportAlert?.(alert.conversationId);
          }}
          className="group cursor-pointer rounded-2xl border-0 bg-white px-4 py-3.5 text-left shadow-[0_18px_46px_rgba(7,15,11,0.16)] ring-1 ring-black/[0.05] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_22px_52px_rgba(7,15,11,0.20)]"
        >
          <span className="mb-1.5 flex items-center justify-between gap-2">
            <span className="min-w-0 truncate text-[13px] font-bold text-giggs-ink">
              {alert.guestName || 'New visitor'}
              <span className="ml-2 inline-flex rounded-full bg-giggs-green/[0.10] px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-giggs-green">Support</span>
            </span>
            <span
              role="button"
              tabIndex={0}
              onClick={(event) => {
                event.stopPropagation();
                dismissSupportAlert?.(alert.conversationId);
              }}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  event.stopPropagation();
                  dismissSupportAlert?.(alert.conversationId);
                }
              }}
              aria-label="Dismiss"
              className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-slate-100 text-giggs-muted transition-colors group-hover:bg-red-50 group-hover:text-red-600"
            >
              <X size={14} />
            </span>
          </span>
          {alert.guestEmail && <span className="mb-1 block truncate text-[11px] font-medium text-giggs-muted">{alert.guestEmail}</span>}
          <span className="block break-words text-[13px] leading-5 text-giggs-text">{alert.preview || 'started a new support chat.'}</span>
        </button>
      ))}
    </div>
  );
};

const AdminMessages = () => {
  return (
    <AdminLayout title="Messages">
      <SupportAlerts />
      <div className="mb-5">
        <h2 className="m-0 font-nunito text-[24px] font-black tracking-[-0.025em] text-giggs-ink sm:text-[28px]">Support inbox</h2>
        <p className="mb-0 mt-1 text-sm leading-6 text-giggs-muted">Respond to client and Gigger conversations from one workspace.</p>
      </div>
      <div className="flex h-[calc(100dvh-205px)] min-h-[560px] overflow-hidden rounded-2xl bg-white shadow-[0_12px_40px_rgba(15,23,42,0.06)] ring-1 ring-black/[0.045]">
        <ChatPanel emptyText="Select a user conversation to respond" />
      </div>
    </AdminLayout>
  );
};

export default AdminMessages;
